import { useTranslation } from 'next-i18next'

const TitleWithEnLabel = ({
  name = '',
  isUpcoming = false,
  isNameLarge = false,
  className = 'text-purple',
}: {
  name?: string
  isUpcoming?: boolean
  isNameLarge?: boolean
  className?: string
}): React.ReactElement => {
  const { t } = useTranslation('bootcamp')
  return (
    <section>
      <span className={`${isNameLarge ? '' : 'mr-2'}`}>{name}</span>
      {isUpcoming && (
        <span className={`tracking-btn-wide inline-block text-xxs font-semibold leading-7 ${className}`}>{`(${t(
          'onlyInEn',
        )})`}</span>
      )}
    </section>
  )
}

export default TitleWithEnLabel
